import {Store} from "@bryntum/schedulerpro";
import {Reminder} from "../../models/Reminder.jsx";
import {SwivuStoreArchiveMixin} from "../mixins/SwivuStoreArchiveMixin.jsx";
import {STORE_KEYS} from "../../../other/constants/StoreKeys.jsx";

export class ReminderStore extends SwivuStoreArchiveMixin(Store) {
  static get $name() {
    return "ReminderStore";
  }

  static get configurable() {
    return {
      id: STORE_KEYS.reminderStore,
      storeId: STORE_KEYS.reminderStore,
      modelClass: Reminder,
    };
  }
}
